/**
 * @file Running.jsx
 * @exports Running
 */
import React from 'react'

const green = '#00C35F'
const defaultColor = green

const Running = function Running ({ style }) {
  const svgStyle = { fill: defaultColor, fillRule: 'nonzero', ...style }

  return (
    <svg
      id='running-icon'
      preserveAspectRatio='xMidYMid meet'
      style={svgStyle}
      viewBox='0 0 20 20'
    >
      <description>equipment is running icon</description>
      <title>running</title>
      <g transform='translate(1,1)'>
        <circle fill='white' stroke={defaultColor} cx='9' cy='9' r='9' />
        <path
          d='M13.2,8.3 L6.8,4.5 C6.2,4.1 5.5,4.5 5.5,5.2 L5.5,12.8 C5.5,13.44 6.2,13.9 6.8,13.5 L13.2,9.9 C13.8,9.5 13.8,8.7 14,8.3 Z M18,9 C18,4 14,0 9,0 C4,0 0,4 0,9 C0,14 4,18 9,18 C14,18 18,14 18,9 Z M1.7,9 C1.7,5 5,1.7 9,1.7 C13,1.7 16,5 16.2,9 C16.2,13 13,16.2 9,16.2 C5,16.2 1.7,13 1.7,9 Z'
        />
      </g>
    </svg>
  )
}

export default Running
